<template>
  <div class="dlg">
    <header class="dlg__head">
      <div class="dlg__eyebrow">
        <span class="dlg__dot"></span>
        WAIZMANNVERGLEICH / SCHNELLÜBERSICHT
      </div>
      <h2 class="dlg__title">Schnellübersicht: Tarife im direkten Vergleich</h2>
      <p class="dlg__sub">
        Preise, Ø-Erstattung und Clearment-Kennzahlen aller passenden Tarife
        nebeneinander.
      </p>
    </header>

    <div class="dlg__table-wrap">
      <table class="dlg__table">
        <thead>
          <tr>
            <th>Tarif</th>
            <th class="dlg__th-num">Preis</th>
            <th class="dlg__th-num">
              Ø-Erstattung
              <span v-if="berechnung.ber_algo_view == 2" class="sv-th-sub">
                KFO/Kind
              </span>
              <span v-else class="sv-th-sub">Zahnersatz/Zahnerhalt</span>
            </th>
            <th>Clearment Vertragsschutz</th>
            <th>Clearment Zertifizierung</th>
            <th>Infopaket</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in alletarife" :key="item.tarif_id">
            <td class="dlg__td-tarif">
              <router-link v-if="item.antraglink" :to="item.antraglink">
                {{ item.un_name }}
              </router-link>
              <span v-else>{{ item.un_name }}</span>
              <span v-if="item.empfehlung_type > 0" class="dlg__tipp">
                Tipp
              </span>
              <div class="dlg__td-tarif-sub">{{ item.tarif_title }}</div>
            </td>
            <td class="dlg__td-num">{{ item.preis_value }} €</td>
            <td class="dlg__td-num">
              <span v-if="berechnung.ber_algo_view == 2">
                {{ item.tarif_kwert_gesamt }} %
              </span>
              <span v-else>{{ item.tarif_waizmannwert }} %</span>
            </td>
            <td>
              <span v-if="item.tarif_clearment_vs > 0" class="dlg__pill dlg__pill--ok">
                Ja, kostenlos
              </span>
              <span v-else class="dlg__pill dlg__pill--warn">
                nicht verfügbar
              </span>
            </td>
            <td>
              <span :class="['dlg__pill', clearmentPillClass(item)]">
                {{ item.tarif_show_lsk_word }}
              </span>
            </td>
            <td>
              <router-link v-if="item.antraglink" :to="item.antraglink" class="dlg__btn">
                Angebot
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
  import { defineProps } from "vue";

  defineProps({
    alletarife: {
      type: Array,
      default: () => [],
    },
    berechnung: {
      type: Object,
      default: () => ({}),
    },
  });

  function clearmentPillClass(item) {
    const style = (item.tarif_show_lsk_style || "").toLowerCase();
    if (style.includes("green")) return "dlg__pill--ok";
    if (style.includes("red") || style.includes("orange")) return "dlg__pill--warn";
    return "dlg__pill--info";
  }
</script>

<style scoped>
  .sv-th-sub {
    display: block;
    font-size: 9.5px;
    font-weight: 600;
    color: #6b7280;
    text-transform: none;
    letter-spacing: 0;
    margin-top: 2px;
  }
</style>
